import React from 'react';
import { FetchResult } from '@apollo/client';

import FadeInContainer from 'buyside/components/presentation/FadeInContainer/fadeInContainer';
import UserGeneratedLink from 'buyside/components/presentation/UserGeneratedLink/UserGeneratedLink';

import { useCreateAdLeadMutation } from 'interfaces/graphql-typings';

import styles from './partnerOfferCardStyles.scss';

const PartnerOfferCard: React.FC<{
  adId: string;
  description: string;
  href: string;
  logoUrl: string;
  title: string;
  cta: string;
}> = ({ adId, description, href, logoUrl, title, cta }) => {
  const [handleCreateAdLead] = useCreateAdLeadMutation({
    variables: { adId }
  });

  return (
    <FadeInContainer>
      <UserGeneratedLink href={href} onClick={(): Promise<FetchResult> => handleCreateAdLead()}>
        <div className={styles.partnerOfferCard}>
          <img alt="partner-logo" src={logoUrl} />
          <div>
            <h3>{title}</h3>
            <p>{description}</p>
            <p>{cta}</p>
          </div>
        </div>
      </UserGeneratedLink>
    </FadeInContainer>
  );
};

export default PartnerOfferCard;
